import React from "react";
import { Button, buttonClasses } from "@mui/material";

/**
 *
 * @param {{
 *  children: JSX.Element;
 *  disabled?: boolean;
 *  onClick: () => void;
 *  color?: "inherit" | "error" | "warning" | "info" | "success" | "secondary" | "primary"
 * }}
 */
const ModalLayoutBtn = ({
  children,
  onClick,
  color,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      color={color}
      disabled={disabled}
      onClick={onClick}
      sx={{
        gap: 0.5,
        marginY: 0.5,
        paddingY: 0.5,
        paddingX: 1.5,
        bgcolor:
          color === "secondary"
            ? "#495057"
            : color === "success"
            ? "#4BBF73"
            : undefined,
        "&:hover": {
          bgcolor:
            color === "secondary"
              ? "#3a3f44"
              : color === "success"
              ? "#3da861"
              : undefined,
        },

        [`&.${buttonClasses.disabled}`]: {
          color: color === "secondary" ? "rgba(255,255,255,0.5)" : "var(--variant-containedColor)",
          backgroundColor: color === "secondary" ? "#495057" : "var(--variant-containedBg)",
          opacity: color === "secondary" ? 0.6 : undefined,
        }
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ModalLayoutBtn;
